(function(){
  var $=function(s,r){return (r||document).querySelector(s);};
  var $$=function(s,r){return Array.prototype.slice.call((r||document).querySelectorAll(s));};
  var money=function(c){return '$'+(c/100).toFixed(2);};

  /* ---------- cart drawer ---------- */
  var drawer=$('[data-cd]');
  function openDrawer(){ if(drawer){drawer.classList.add('is-open');document.body.style.overflow='hidden';} }
  function closeDrawer(){ if(drawer){drawer.classList.remove('is-open');document.body.style.overflow='';} }
  if(drawer){
    $$('[data-cd-close]',drawer).forEach(function(b){b.addEventListener('click',closeDrawer);});
  }
  document.addEventListener('click',function(e){ var t=e.target.closest('[data-open-cart]'); if(t){e.preventDefault();openDrawer();refreshCart();} });

  /* ---------- sidebar menu ---------- */
  var menu=$('[data-menu]');
  function openMenu(){ if(menu){menu.classList.add('is-open');document.body.style.overflow='hidden';} }
  function closeMenu(){ if(menu){menu.classList.remove('is-open');document.body.style.overflow='';} }
  document.addEventListener('click',function(e){ var t=e.target.closest('[data-open-menu]'); if(t){e.preventDefault();openMenu();} });
  if(menu){ $$('[data-menu-close]',menu).forEach(function(b){b.addEventListener('click',closeMenu);}); }

  function renderCart(cart){
    var body=$('[data-cd-body]'), foot=$('[data-cd-subtotal]'), count=$$('[data-cart-count]');
    count.forEach(function(c){c.textContent=cart.item_count; c.style.display=cart.item_count>0?'':'none';});
    if(foot)foot.textContent=money(cart.total_price);
    if(!body)return;
    if(!cart.items.length){body.innerHTML='<p style="color:var(--mute);padding:30px 0;text-align:center">Your cart is empty.</p>';return;}
    body.innerHTML=cart.items.map(function(it){
      return '<div class="pm-cartrow"><img class="pm-cartrow__img" src="'+(it.image?it.image.replace(/(\.[a-z]+)(\?|$)/,'_120x$1$2'):'')+'" alt=""><div class="pm-cartrow__b"><strong>'+it.product_title+'</strong><span>'+(it.variant_title||'')+'</span><span>Qty '+it.quantity+'</span><button class="pm-cartrow__rm" data-remove="'+it.key+'">Remove</button></div><div class="pm-cartrow__p">'+money(it.final_line_price)+'</div></div>';
    }).join('');
  }
  function refreshCart(){ fetch('/cart.js').then(function(r){return r.json();}).then(renderCart).catch(function(){}); }

  /* ---------- cart drawer bundle upsell (one-click add) ---------- */
  document.addEventListener('click',function(e){
    var b=e.target.closest('[data-add-bundle]'); if(!b)return;
    e.preventDefault();
    var handle=b.getAttribute('data-add-bundle'); var old=b.innerHTML; b.innerHTML='Adding…';
    fetch('/products/'+handle+'.js').then(function(r){ if(!r.ok) throw 0; return r.json(); })
      .then(function(prod){ var v=(prod.variants||[]).filter(function(x){return x.available;})[0]||prod.variants[0]; return addToCart(v.id,1); })
      .then(function(){ b.innerHTML='Added ✓'; setTimeout(function(){b.innerHTML=old;},1200); })
      .catch(function(){ window.location.href='/products/'+handle; });
  });
  refreshCart();

  function addToCart(id,qty){
    return fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[{id:id,quantity:qty||1}]})})
      .then(function(r){return r.json();})
      .then(function(){ return fetch('/cart.js').then(function(r){return r.json();}); })
      .then(function(cart){ renderCart(cart); openDrawer(); return cart; });
  }

  /* ---------- product buy box ---------- */
  var box=$('[data-buybox]');
  if(box){
    var variants=[]; try{variants=JSON.parse($('[data-variants]',box).textContent);}catch(e){}
    var selId=box.getAttribute('data-default-id');
    var packs=$$('[data-pack]',box);
    packs.forEach(function(p){
      p.addEventListener('click',function(){
        packs.forEach(function(x){x.classList.remove('is-on');});
        p.classList.add('is-on');
        selId=p.getAttribute('data-vid');
        var fid=document.querySelector('[data-form-id]'); if(fid&&selId)fid.value=selId;
        var pr=p.getAttribute('data-price'), was=p.getAttribute('data-compare');
        var now=$('[data-price-now]',box), wasEl=$('[data-price-was]',box), off=$('[data-price-off]',box);
        if(now&&pr)now.textContent=money(pr);
        if(wasEl&&was){wasEl.textContent=money(was);}
        if(off&&was&&pr){off.textContent='SAVE '+Math.round((was-pr)/was*100)+'%';}
        var sp=$('[data-sticky-price]'); if(sp&&pr)sp.textContent=money(pr);
      });
    });
    var atc=$('[data-atc]',box);
    function doAdd(){ if(!selId)return; var b=atc; var old=b.innerHTML; b.innerHTML='Adding…'; addToCart(selId,1).then(function(){b.innerHTML='Added ✓';setTimeout(function(){b.innerHTML=old;},1200);}).catch(function(){b.innerHTML=old;}); }
    if(atc)atc.addEventListener('click',doAdd);
    var satc=$('[data-sticky-atc]'); if(satc)satc.addEventListener('click',doAdd);
    /* gallery thumbs */
    $$('[data-thumb]',box).forEach(function(t){t.addEventListener('click',function(){ $$('[data-thumb]',box).forEach(function(x){x.classList.remove('is-on');}); t.classList.add('is-on'); var main=$('[data-gal-main]',box); var full=t.getAttribute('data-full'); var img=t.querySelector('img'); var src=full||(img&&img.src); if(main&&src){var m=main.querySelector('img'); if(m){m.removeAttribute('srcset');m.removeAttribute('sizes');m.src=src;}} });});
  }

  /* ---------- sticky bar reveal ---------- */
  var sticky=$('[data-sticky]'); var anchor=$('[data-atc]');
  if(sticky&&anchor&&'IntersectionObserver' in window){
    new IntersectionObserver(function(es){es.forEach(function(e){sticky.classList.toggle('is-on',!e.isIntersecting);});},{rootMargin:'0px 0px -60px 0px'}).observe(anchor);
  }

  /* ---------- countdown ---------- */
  $$('[data-count]').forEach(function(el){
    var target=Date.parse(el.getAttribute('data-count'));
    if(isNaN(target))return;
    var out=$$('[data-seg]',el);
    function pad(n){return(n<10?'0':'')+n;}
    function tick(){
      var d=Math.floor((target-Date.now())/1000);
      if(d<=0){d=0;}
      var days=Math.floor(d/86400),h=Math.floor((d%86400)/3600),m=Math.floor((d%3600)/60),s=d%60;
      var vals=[days,h,m,s];
      out.forEach(function(seg,i){var b=seg.querySelector('b'); if(b)b.textContent=pad(vals[i]);});
    }
    tick(); setInterval(tick,1000);
  });

  /* ---------- rolling midnight countdown (loops daily) ---------- */
  $$('[data-midnight]').forEach(function(el){
    var out=$$('[data-seg]',el);
    function pad(n){return(n<10?'0':'')+n;}
    function tick(){
      var now=new Date();
      var end=new Date(now.getFullYear(),now.getMonth(),now.getDate()+1,0,0,0,0);
      var d=Math.floor((end-now)/1000); if(d<0)d=0;
      var h=Math.floor(d/3600),m=Math.floor((d%3600)/60),s=d%60;
      var vals=[h,m,s];
      out.forEach(function(seg,i){var b=seg.querySelector('b'); if(b)b.textContent=pad(vals[i]);});
    }
    tick(); setInterval(tick,1000);
  });

  /* ---------- live viewers ---------- */
  $$('[data-viewers]').forEach(function(el){
    var n=el.querySelector('[data-vn]');
    var mn=+el.getAttribute('data-min')||14, mx=+el.getAttribute('data-max')||40;
    var cur=Math.floor(Math.random()*(mx-mn+1))+mn; if(n)n.textContent=cur;
    setInterval(function(){cur+=Math.round((Math.random()-.5)*4); if(cur<mn)cur=mn+1; if(cur>mx)cur=mx-1; if(n)n.textContent=cur;},3000);
  });

  /* ---------- recent-sale toasts ---------- */
  var toast=$('[data-toast]');
  if(toast){
    var names=(toast.getAttribute('data-names')||'').split(',').map(function(s){return s.trim();}).filter(Boolean);
    var places=(toast.getAttribute('data-places')||'').split(',').map(function(s){return s.trim();}).filter(Boolean);
    var prod=toast.getAttribute('data-product')||'this';
    var txt=$('[data-toast-txt]',toast);
    var mins=['2 minutes','6 minutes','11 minutes','18 minutes','27 minutes','an hour','2 hours'];
    function rnd(a){return a[Math.floor(Math.random()*a.length)];}
    function show(){ if(!names.length)return; txt.innerHTML='<strong>'+rnd(names)+'</strong> in '+rnd(places)+' just bought the '+prod+'<span class="pm-toast__ago">'+rnd(mins)+' ago · Verified</span>'; toast.classList.add('is-in'); setTimeout(function(){toast.classList.remove('is-in');},5000); }
    setTimeout(function(){show(); setInterval(show,12000);},4500);
  }
  document.addEventListener('click',function(e){
  var r=e.target.closest('[data-remove]'); if(!r)return; e.preventDefault();
  var key=r.getAttribute('data-remove'); r.textContent='Removing…';
  fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:key,quantity:0})})
    .then(function(res){return res.json();}).then(renderCart).catch(function(){ r.textContent='Remove'; });
});
})();
